import { SplitterDesignTokens } from '@primeuix/themes/types/splitter';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/splitter/index.ts
const spl = componentCommon.splitter;

export const SplitterTelekomDT: SplitterDesignTokens = {
  root: {
    background: t(spl.background),
    color: t(spl.color),
    borderColor: t(spl.border.color),
  },
  gutter: {
    background: t(spl.gutter.background),
  },
  handle: {
    size: t(spl.handle.size),
    background: t(spl.handle.background),
    borderRadius: t(spl.handle.border.radius),
    focusRing: {
      width: t(spl.handle.focus.ring.width),
      color: t(spl.handle.focus.ring.color),
      offset: t(spl.handle.focus.ring.offset),
    },
  },
};
